import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LogoffPage.css';

const LogoffPage = () => {
  const navigate = useNavigate();
  const [logoffComplete, setLogoffComplete] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const performLogoff = async () => {
      try {
        const userString = localStorage.getItem('user');
        const user = userString ? JSON.parse(userString) : null;

        // Clear all authentication data
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('okta_token');
        localStorage.removeItem('okta_login_token');
        localStorage.removeItem('okta_api_token');
        localStorage.removeItem('okta_state');
        sessionStorage.clear();

        // If user logged in via Okta, redirect to Okta logout endpoint
        const oktaIssuer = process.env.REACT_APP_OKTA_ISSUER;
        const postLogoutUri = `${window.location.origin}/logoff`;

        if (oktaIssuer && user && user.auth_method === 'okta' && user.id_token) {
          const logoutUrl = new URL(oktaIssuer + '/v1/logout');
          logoutUrl.searchParams.set('id_token_hint', user.id_token);
          logoutUrl.searchParams.set('post_logout_redirect_uri', postLogoutUri);
          window.location.href = logoutUrl.toString();
          return;
        }
      } catch (err) {
        console.error('Error during logoff:', err);
      }

      setLogoffComplete(true);
    };

    // Check if this is a return from Okta logout (post_logout_redirect_uri)
    const isReturnFromOkta = !localStorage.getItem('user') && !localStorage.getItem('isAuthenticated');
    if (isReturnFromOkta) {
      setLogoffComplete(true);
    } else {
      performLogoff();
    }
  }, []);

  useEffect(() => {
    if (!logoffComplete) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login', { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [logoffComplete, navigate]);

  const handleLoginRedirect = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div className="logoff-page">
      <div className="logoff-container">
        <div className="logoff-icon">&#128075;</div>

        {!logoffComplete ? (
          <div className="logoff-loading">
            <div className="logoff-spinner"></div>
            <h2>Signing you out...</h2>
            <p>Please wait while we securely end your session.</p>
          </div>
        ) : (
          <div className="logoff-complete">
            <h2>You've been signed out</h2>
            <p>Your session has been securely ended.</p>

            <div className="logoff-info">
              <p>For security, please close your browser if you're on a shared computer.</p>
            </div>

            <button className="btn-login-redirect" onClick={handleLoginRedirect}>
              Sign In Again
            </button>

            <p className="redirect-notice">
              Redirecting to login page in <strong>{countdown}</strong> seconds...
            </p>
          </div>
        )}

        <div className="logoff-footer">
          <p>&copy; 2026 Connect Agent Setup Portal</p>
        </div>
      </div>
    </div>
  );
};

export default LogoffPage;